/** Action Type to login request */
export const FETCH_LOGIN_REQUEST = 'FETCH_LOGIN_REQUEST';

/** Action Type to fetch login data */
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS';

/** Action Type to fetch login data failure */
export const FETCH_LOGIN_FAILURE = 'FETCH_LOGIN_FAILURE';

export const SET_LOADING_SIGN_IN = 'SET_LOADING_SIGN_IN';